// extracted by mini-css-extract-plugin
export var responsiveButton = "search-box-module--responsiveButton--894d1";
export var searchBox = "search-box-module--searchBox--71aba";
export var searchButton = "search-box-module--searchButton--51e4d";
export var searchWrapper = "search-box-module--searchWrapper--ea6ff";